export default "__VITE_ASSET__CfTqeq6X__"